module.exports = {"name":"おてつたび","short_name":"おてつたび","theme_color":"#FFEECB","background_color":"#FFEECB","display":"minimal-ui","orientation":"portrait"}